<template>
  <v-data-table
    class="mt-4"
    mobile-breakpoint="0"
    :items-per-page="5"
    item-key="studentCode"
    :headers="originHeaders"
    :items="priceStudent"
    :footer-props="{
      'items-per-page-text': 'Hiển thị mỗi trang',
      'items-per-page-all-text': 'Tất cả'
    }"
    disable-sort
  >
    <template v-slot:[`item.index`]="{ item }">
      {{ item.index }}
    </template>
    <template v-slot:[`item.teacher`]="{ item }">
      <CardTeacherName :teacher="item" link isCodeShown />
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      {{ item.dob | ddmmyyyy }}
    </template>
    <template v-slot:[`item.gender`]="{ item }">
      {{ item.gender | gender }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small :color="item.status | statusColor"
        ><span class="white--text">{{ item.status | status }}</span></v-chip
      >
    </template>
    <template v-slot:[`item.price`]="{ item }">
      <span
        >{{ item.price && item.price.toLocaleString('en-US')
        }}{{ item.price && item.type === 'percentage' ? '%' : ' VNĐ' }}</span
      >
    </template>
  </v-data-table>
</template>

<script>
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'

export default {
  components: {
    CardTeacherName
  },
  props: {
    priceStudent: Array,
    selected: Boolean
  },
  data() {
    return {
      originHeaders: [
        { text: 'STT', value: 'index' },
        { text: 'Giáo viên', value: 'teacher' },
        { text: 'Ngày sinh', value: 'dob', width: 100 },
        { text: 'Giới tính', value: 'gender' },
        { text: 'Trạng thái', value: 'status', align: 'center' },
        { text: `Mức chi/thu`, value: 'price' },
        { text: 'Ghi chú riêng', value: 'notes' }
      ]
    }
  }
}
</script>

<style>
.text-error {
  color: #fd6b6b;
}
</style>
